'use client'

import { ReactNode } from 'react'
import { IS_PRODUCTION_DEPLOYMENT } from '@/config/environments.config'
import type { TestStateProps } from '@/types/testing.types'

/**
 * Renders a hidden, non-production-only JSON snapshot of app state for Playwright
 * e2e tests to read directly from the DOM (via `data-testid`), instead of
 * intercepting and deserializing server action (React Flight) responses.
 *
 * See `playwright/support/api.ts` for the readers (`getCart`, `getEventTickets`, etc.).
 *
 * @param {string} id - the `data-testid` used to locate the snapshot
 * @param {unknown} data - any JSON-serializable value to expose (always emits valid JSON)
 */
const TestState = ({ id, data }: TestStateProps): ReactNode => {
  if (IS_PRODUCTION_DEPLOYMENT) return null

  return (
    <div hidden data-testid={id}>
      {JSON.stringify(data ?? null)}
    </div>
  )
}

export default TestState
